export const iconFontAwesomeGamingPlaystation = (
	<i className="fa-solid fa-playstation"></i>
);
